import React, { useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Dropdown from 'components/v2/dropdowns/DropdownV2';
import ListItemForm from './ListItemForm';
import ListItemSummary from './ListItemSummary';
export default function ListItem({ className, children, form, actions, actionsEnabled, actionLabel, cancelLabel, showCancelButton, testDataId, actionTestDataId, cancelTestDataId, }) {
    const [formViewVisible, setShowFormViewVisible] = useState(false);
    const [saving, setSaving] = useState(false);
    const [selectedView, setSelectedView] = useState('');
    function showFormView() {
        setShowFormViewVisible(true);
    }
    function hideFormView() {
        setShowFormViewVisible(false);
    }
    function handleSaveSuccess() {
        setSaving(false);
    }
    function selectView(view) {
        setSelectedView(view);
    }
    function handleSaveFail() {
        setSaving(false);
    }
    function handleActionClick() {
        setSaving(true);
    }
    function handleCancel() {
        setShowFormViewVisible(false);
    }
    function renderForm() {
        if (!formViewVisible || !form) {
            return null;
        }
        return (React.createElement(ListItemForm, { onActionClick: handleActionClick, onCancelClick: handleCancel, actionLabel: actionLabel, cancelLabel: cancelLabel, showCancelButton: showCancelButton, buttonsDisabled: saving, actionTestDataId: actionTestDataId, cancelTestDataId: cancelTestDataId }, form(saving, handleSaveSuccess, handleSaveFail, hideFormView)));
    }
    return (React.createElement(React.Fragment, null,
        !formViewVisible && (React.createElement(ListItemSummary, { className: classNames('flex justify-between space-x-3', className) },
            children(selectedView),
            actionsEnabled && actions && (React.createElement(Dropdown, { useIcon: true, className: "", testDataId: testDataId }, actions(showFormView, selectView))))),
        renderForm()));
}
ListItem.propTypes = {
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.array,
    ]),
    children: PropTypes.func.isRequired,
    form: PropTypes.func,
    actions: PropTypes.func,
    actionsEnabled: PropTypes.bool,
    showCancelButton: PropTypes.bool,
    testDataId: PropTypes.string,
};
ListItem.defaultProps = {
    actionsEnabled: true,
    showCancelButton: true,
    testDataId: 'actions-dropdown-button',
};
